import api from "./api";
import { DeliveryType } from "../components/References/Delivery/deliveryType";
export type DeleteComponentDto = {
  id: number | string;
};

/*Search & filter */
export const getDeliveryApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/delivery?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url)
};

/*select */
export const getDeliveryById = async (componentId: string | undefined) => {
  return await api.get(`/delivery/${componentId}`);
};
export const createDelivery = async (componentDetails: DeliveryType) => {
  return await api.post("/delivery", componentDetails);
};
export const editDelivery = async (componentId: any, body: DeliveryType) => {
  return await api.put(`/delivery/${componentId}`, body);
};
export const deleteDelivery = async (dto: DeleteComponentDto) => {
  return await api.delete(`/delivery/${dto.id}`);
};


export const getComponentsDropdown = async () => {
  return await api.get("/components/dropdown");
};